<template>
  <b-nav-item-dropdown right no-caret>
    <template slot="button-content">
      <i class="fa fa-angle-down"></i>
    </template>
    <b-dropdown-item @click="logout()"><i class="fa fa-sign-out"></i> ログアウト</b-dropdown-item>
  </b-nav-item-dropdown>
</template>
<script>
import Store from '@/store'
export default {
  name: 'header-dropdown',
  methods: {
    logout () {
      var res = confirm('ログアウトします。よろしいですか？')
      if (res) {
        Store.commit('logout')
        this.$router.push('/Login')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header/HeaderDropdown.vue